module.exports = __webpack_public_path__ + "img/pdf.a251bd42.png";